import React from 'react';
import { Grid } from '@material-ui/core';
import { CspDetailItem } from '../../../Csp/components';

interface CspInfo {
  companyName?: string;
  email?: string;
  uid?: string;
  phone?: string;
}

interface CampaignCspDetailsProps {
  cspInfo: CspInfo;
}

const CampaignCspDetails: React.FC<CampaignCspDetailsProps> = ({ cspInfo }) => {
  return (
    <Grid container>
      <Grid item xs={6}>
        <CspDetailItem title="CSP Legal Name" value={cspInfo?.companyName} />
        <CspDetailItem title="Email Address" value={cspInfo?.email} />
      </Grid>
      <Grid item xs={6}>
        <CspDetailItem title="CSP ID" value={cspInfo?.uid} />
        <CspDetailItem title="Phone Number" value={cspInfo?.phone} />
      </Grid>
    </Grid>
  );
};

export default CampaignCspDetails;
